import { createSelector, createFeatureSelector } from '@ngrx/store';

import { SoilTypeState } from '../models/soil-type.models';

export const selectSoilTypeState = createFeatureSelector<SoilTypeState>('soilType');
export const selectSoilTypes = createSelector(
  selectSoilTypeState,
  (state) => state?.soilTypes ?? [],
);
